var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-aura app-aura-left"}),_c('div',{staticClass:"app-aura app-aura-right"}),_c('main',{staticClass:"app-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }